<template>
    <ul class="breadcrumbs">
        <li
            v-if="haveParent"
            class="breadcrumbs__option breadcrumbs__option--parent position--relative display--inline-b color--grey capitalize"
        >
            <router-link
                class="breadcrumbs__option__anchor accessibility--outline accessibility--active"
                :to="`/${$route.meta.parent}`"
            >
               <span class="breadcrumbs__option__anchor__text">{{ parent }}</span>
            </router-link>
        </li>
        <li class="breadcrumbs__option display--inline-b color--green capitalize">
            <h1 class="breadcrumbs__option__static">{{ $t(`global.${$route.name}`) }}</h1>
        </li>
    </ul>
</template>

<script>
// packages
import { reactive, computed, watch } from '@vue/composition-api';

// i18n
import i18n from '@/plugins/i18n';

export default {
    setup ( _, { root }) {
        // tornar routes reactivas
        const route = root.$route;
        const state = reactive({ route });

        watch( () => root.$route,
            newRoute => {
                state.route = newRoute;
            });

        // valida se a rota não tem parente
        const haveParent = computed( () => state.route.meta.parent );

        // obtém a tradução do parente
        const parent = computed( () => ( haveParent ? i18n.t( `global.${state.route.meta.parent}` ) : '' ) );

        return { haveParent, parent };
    }
};
</script>

<style lang="scss">
    .breadcrumbs {
        @include typography-specs( 35px, 46px, 500 );
        &__option {
            &--parent {
                margin-right: 32px;
                &::after {
                    @include pseudo();
                    @include transform-position( 50%, -20px, false, false, translateY( -50% ) rotate( 45deg) );
                    @include dimensions( 12px, 12px );
                    border-top: solid 3px currentColor;
                    border-right: solid 3px currentColor;
                }
            }
        }
    }
</style>